/* tslint:disable */
/* eslint-disable */
/**
 * SPD
 * Opis api SPD
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface CreateUpdateJudgmentDto
 */
export interface CreateUpdateJudgmentDto {
    /**
     * 
     * @type {string}
     * @memberof CreateUpdateJudgmentDto
     */
    number?: string | null;
    /**
     * 
     * @type {number}
     * @memberof CreateUpdateJudgmentDto
     */
    lp?: number | null;
    /**
     * 
     * @type {string}
     * @memberof CreateUpdateJudgmentDto
     */
    examId?: string | null;
    /**
     * 
     * @type {Date}
     * @memberof CreateUpdateJudgmentDto
     */
    nextExamDate?: Date | null;
    /**
     * 
     * @type {Date}
     * @memberof CreateUpdateJudgmentDto
     */
    judgmentDate?: Date | null;
    /**
     * 
     * @type {string}
     * @memberof CreateUpdateJudgmentDto
     */
    articleId?: string | null;
    /**
     * 
     * @type {string}
     * @memberof CreateUpdateJudgmentDto
     */
    psychologistUID?: string | null;
    /**
     * 
     * @type {boolean}
     * @memberof CreateUpdateJudgmentDto
     */
    pass?: boolean | null;
    /**
     * 
     * @type {string}
     * @memberof CreateUpdateJudgmentDto
     */
    occupationalMedicineOneCategory?: string | null;
    /**
     * 
     * @type {string}
     * @memberof CreateUpdateJudgmentDto
     */
    occupationalMedicineText?: string | null;
    /**
     * 
     * @type {string}
     * @memberof CreateUpdateJudgmentDto
     */
    vehicleRestriction?: string | null;
    /**
     * 
     * @type {string}
     * @memberof CreateUpdateJudgmentDto
     */
    personRestriction?: string | null;
    /**
     * 
     * @type {string}
     * @memberof CreateUpdateJudgmentDto
     */
    drivingLicense?: string | null;
    /**
     * 
     * @type {string}
     * @memberof CreateUpdateJudgmentDto
     */
    roadTransport?: string | null;
    /**
     * 
     * @type {boolean}
     * @memberof CreateUpdateJudgmentDto
     */
    active?: boolean | null;
    /**
     * 
     * @type {boolean}
     * @memberof CreateUpdateJudgmentDto
     */
    withoutSign?: boolean | null;
    /**
     * 
     * @type {boolean}
     * @memberof CreateUpdateJudgmentDto
     */
    twilightVision?: boolean | null;
    /**
     * 
     * @type {boolean}
     * @memberof CreateUpdateJudgmentDto
     */
    glareSensitivity?: boolean | null;
    /**
     * 
     * @type {string}
     * @memberof CreateUpdateJudgmentDto
     */
    comment?: string | null;
    /**
     * 
     * @type {string}
     * @memberof CreateUpdateJudgmentDto
     */
    cardId?: string | null;
    /**
     * 
     * @type {boolean}
     * @memberof CreateUpdateJudgmentDto
     */
    art39j?: boolean | null;
    /**
     * 
     * @type {boolean}
     * @memberof CreateUpdateJudgmentDto
     */
    contactWithFood?: boolean | null;
    /**
     * 
     * @type {Date}
     * @memberof CreateUpdateJudgmentDto
     */
    dateFrom?: Date | null;
    /**
     * 
     * @type {Date}
     * @memberof CreateUpdateJudgmentDto
     */
    dateTo?: Date | null;
    /**
     * 
     * @type {boolean}
     * @memberof CreateUpdateJudgmentDto
     */
    requiresCorrectiveEyewear?: boolean | null;
    /**
     * 
     * @type {boolean}
     * @memberof CreateUpdateJudgmentDto
     */
    generatedByAutomat?: boolean | null;
    /**
     * 
     * @type {string}
     * @memberof CreateUpdateJudgmentDto
     */
    statusP1: CreateUpdateJudgmentDtoStatusP1Enum | null;
    /**
     * 
     * @type {boolean}
     * @memberof CreateUpdateJudgmentDto
     */
    acknowledgedDuplicate?: boolean | null;
}


/**
 * @export
 */
export const CreateUpdateJudgmentDtoStatusP1Enum = {
    ToSign: 'ToSign',
    WaitingForP1: 'WaitingForP1',
    AcceptedInP1: 'AcceptedInP1',
    RejectedInP1: 'RejectedInP1',
    ValidationFailed: 'ValidationFailed'
} as const;
export type CreateUpdateJudgmentDtoStatusP1Enum = typeof CreateUpdateJudgmentDtoStatusP1Enum[keyof typeof CreateUpdateJudgmentDtoStatusP1Enum];


/**
 * Check if a given object implements the CreateUpdateJudgmentDto interface.
 */
export function instanceOfCreateUpdateJudgmentDto(value: object): value is CreateUpdateJudgmentDto {
    if (!('statusP1' in value) || value['statusP1'] === undefined) return false;
    return true;
}

export function CreateUpdateJudgmentDtoFromJSON(json: any): CreateUpdateJudgmentDto {
    return CreateUpdateJudgmentDtoFromJSONTyped(json, false);
}

export function CreateUpdateJudgmentDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): CreateUpdateJudgmentDto {
    if (json == null) {
        return json;
    }
    return {
        
        'number': json['number'] == null ? undefined : json['number'],
        'lp': json['lp'] == null ? undefined : json['lp'],
        'examId': json['examId'] == null ? undefined : json['examId'],
        'nextExamDate': json['nextExamDate'] == null ? undefined : (new Date(json['nextExamDate'])),
        'judgmentDate': json['judgmentDate'] == null ? undefined : (new Date(json['judgmentDate'])),
        'articleId': json['articleId'] == null ? undefined : json['articleId'],
        'psychologistUID': json['psychologistUID'] == null ? undefined : json['psychologistUID'],
        'pass': json['pass'] == null ? undefined : json['pass'],
        'occupationalMedicineOneCategory': json['occupationalMedicineOneCategory'] == null ? undefined : json['occupationalMedicineOneCategory'],
        'occupationalMedicineText': json['occupationalMedicineText'] == null ? undefined : json['occupationalMedicineText'],
        'vehicleRestriction': json['vehicleRestriction'] == null ? undefined : json['vehicleRestriction'],
        'personRestriction': json['personRestriction'] == null ? undefined : json['personRestriction'],
        'drivingLicense': json['drivingLicense'] == null ? undefined : json['drivingLicense'],
        'roadTransport': json['roadTransport'] == null ? undefined : json['roadTransport'],
        'active': json['active'] == null ? undefined : json['active'],
        'withoutSign': json['withoutSign'] == null ? undefined : json['withoutSign'],
        'twilightVision': json['twilightVision'] == null ? undefined : json['twilightVision'],
        'glareSensitivity': json['glareSensitivity'] == null ? undefined : json['glareSensitivity'],
        'comment': json['comment'] == null ? undefined : json['comment'],
        'cardId': json['cardId'] == null ? undefined : json['cardId'],
        'art39j': json['art39j'] == null ? undefined : json['art39j'],
        'contactWithFood': json['contactWithFood'] == null ? undefined : json['contactWithFood'],
        'dateFrom': json['dateFrom'] == null ? undefined : (new Date(json['dateFrom'])),
        'dateTo': json['dateTo'] == null ? undefined : (new Date(json['dateTo'])),
        'requiresCorrectiveEyewear': json['requiresCorrectiveEyewear'] == null ? undefined : json['requiresCorrectiveEyewear'],
        'generatedByAutomat': json['generatedByAutomat'] == null ? undefined : json['generatedByAutomat'],
        'statusP1': json['statusP1'],
        'acknowledgedDuplicate': json['acknowledgedDuplicate'] == null ? undefined : json['acknowledgedDuplicate'],
    };
}

export function CreateUpdateJudgmentDtoToJSON(value?: CreateUpdateJudgmentDto | null): any {
    if (value == null) {
        return value;
    }
    return {
        
        'number': value['number'],
        'lp': value['lp'],
        'examId': value['examId'],
        'nextExamDate': value['nextExamDate'] == null ? undefined : ((value['nextExamDate'] as any).toISOString()),
        'judgmentDate': value['judgmentDate'] == null ? undefined : ((value['judgmentDate'] as any).toISOString()),
        'articleId': value['articleId'],
        'psychologistUID': value['psychologistUID'],
        'pass': value['pass'],
        'occupationalMedicineOneCategory': value['occupationalMedicineOneCategory'],
        'occupationalMedicineText': value['occupationalMedicineText'],
        'vehicleRestriction': value['vehicleRestriction'],
        'personRestriction': value['personRestriction'],
        'drivingLicense': value['drivingLicense'],
        'roadTransport': value['roadTransport'],
        'active': value['active'],
        'withoutSign': value['withoutSign'],
        'twilightVision': value['twilightVision'],
        'glareSensitivity': value['glareSensitivity'],
        'comment': value['comment'],
        'cardId': value['cardId'],
        'art39j': value['art39j'],
        'contactWithFood': value['contactWithFood'],
        'dateFrom': value['dateFrom'] == null ? undefined : ((value['dateFrom'] as any).toISOString()),
        'dateTo': value['dateTo'] == null ? undefined : ((value['dateTo'] as any).toISOString()),
        'requiresCorrectiveEyewear': value['requiresCorrectiveEyewear'],
        'generatedByAutomat': value['generatedByAutomat'],
        'statusP1': value['statusP1'],
        'acknowledgedDuplicate': value['acknowledgedDuplicate'],
    };
}

